import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const CACHEABLE_URL_PATTERNS = [
	'/resourceapi',
	'GetMFProductsBystylenumber',
	'api/GetMFRelatedproductsByStyleNumber'
];

@Injectable()
export class ResourceApiCacheInterceptor implements HttpInterceptor {
	private cache = new Map<string, HttpResponse<any>>();

	constructor(@Inject(PLATFORM_ID) private platformId: any) {}

	private isCacheable(url: string): boolean {
		return CACHEABLE_URL_PATTERNS.some(pattern => url.includes(pattern));
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!isPlatformBrowser(this.platformId) || req.method !== 'GET' || !this.isCacheable(req.url)) {
			return next.handle(req);
		}

		// For resourceapi: strip query params — page structure is path-based
		// For product APIs: full URL is the key (style number is in the path)
		const cacheKey = req.url.includes('/resourceapi')
			? req.url.split('?')[0]
			: req.url;

		const cached = this.cache.get(cacheKey);

		if (cached) {
			return of(cached.clone());
		}

		return next.handle(req).pipe(
			tap(event => {
				if (event instanceof HttpResponse) {
					this.cache.set(cacheKey, event);
				}
			})
		);
	}
}
